<!-- 其它商品 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>商品名称</span>
          <el-input
            v-model="queryInfo.name"
            clearable
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </div>

        <!-- <el-button type="primary" size="small" @click="queryTable('search')"
        >搜索</el-button
      >
      <el-button type="warning" size="small" @click="resetQuery"
        >重置</el-button
      > -->

        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>

        <!-- <div
          style="
            display: inline-block;
            margin: 0 30px;
            color: #9583ff;
            cursor: pointer;
          "
          @click="instructionsClick"
        >
          开通商品使用说明
          <i class="el-icon-question el-icon--right" slot="reference"></i>
        </div> -->

        <!-- <el-button type="success" size="small" @click="openKamil"
        >使用卡密开通</el-button
      > -->

        <!-- <MyButton
          v-if="is_study_card"
          value="使用卡密开通"
          size="medium"
          type="3"
          @click="openKamil"
        ></MyButton> -->
      </div>
      <!-- <div class="addInfo">
      <el-button type="success" size="small" @click="downloadExcel"
        >下载批量导入模版</el-button
      >
      <el-button type="success" size="small" @click="skipImportRecord"
        >查看导入记录</el-button
      >
    </div> -->
      <div class="table">
        <TableComponents
          :columns="columns"
          :tableData="tableList"
          :tableFunction="tableFunction"
        >
          <template slot="teachExtend" slot-scope="{ row }">
            <div class="teach-extend-box">
              <span>{{ row.tc_per_txt }} * 销售价</span>
              <span class="teach-extend-box-tc">({{ row.teacher_tc }})</span>
            </div>
          </template>
          <template slot="tob_good_status_name" slot-scope="{ row }">
            <div class="tob_good_status_box"> 
              <el-popconfirm
                :title="
                  row.tob_good_status === 0 ? '是否切换为显示？' : '是否切换为隐藏？（隐藏后将不在APP上显示该商品）'
                "
                @confirm="changeShowOrHidden(row)"
              >
                <el-button
                  slot="reference"
                  :type="row.tob_good_status == 0 ? 'info' : 'success'"
                >
                  {{ row.tob_good_status_name }}
                </el-button>
              </el-popconfirm> 
            </div>
          </template>
          <template slot="operation" slot-scope="{ row }"> 
            <span class="operationItemNew" @click="openKefu(row)">开通</span>

            <!-- <el-popover
              placement="bottom"
              trigger="hover"
              popper-class="accountManage"
            >
              <div> 
                <div
                  class="hoverRed"
                  @click="skipStudent(row)"
                  v-if="!isSalespersonr"
                >
                  从学员列表导入
                </div>
                <div v-if="!isNstitutionalteacher" class="hoverRed" @click="SkipImportStudent(row)">
                  查看已开通学员
                </div>
              </div>
              <span slot="reference" class="operationItemNew">开通</span>
            </el-popover> -->
            <span v-if="!isSalespersonr&&!isNstitutionalteacher" style="color: #e7eaf0; padding: 0 10px">|</span>
            <span
              class="operationItem"
              @click="viewDetail(row, 0)"
              v-if="!isSalespersonr&&!isNstitutionalteacher"
              >改价</span
            >
            <span style="color: #e7eaf0; padding: 0 10px">|</span>
            <span class="operationItem" @click="viewDetail(row, 1)">详情</span>
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <div v-if="userShow" class="courseDetail">
        <p>商品名称：{{ userInfo.name }}</p>
        <p>商品类型：{{ userInfo.goods_type_name }}</p>
        <p>权益说明：{{ userInfo.intro_desc }}</p>
        <p>有效期：{{ userInfo.day }}</p>
        <p v-if="userInfo.tob_img_url">详情图片：</p>
        <div v-if="userInfo.tob_img_url">
          <img style="width: 100%" :src="userInfo.tob_img_url" alt="" />
        </div>
      </div>
      <div v-else>
        <el-form
          :model="userInfo"
          :rules="rules"
          ref="userInfoForm"
          label-width="100px"
        >
          <div class="userInfoFormStyle">
            <p class="t1">商品名称：</p>
            <p class="t2">{{ userInfo.good_name }}</p>
          </div>
          <el-form-item label="销售价：" prop="good_price">
            <el-input
              v-model="userInfo.good_price"
              placeholder="请输入正常销售价"
              :disabled="role != 'admin' && role != 'generaladministrato'"
              size="mini"
            ></el-input>
            <el-popover placement="top-start" width="200" trigger="hover">
              <div>在备考通app上显示的销售价格</div>
              <i class="el-icon-question el-icon--right" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="划线价：" prop="line_price">
            <el-input
              v-model="userInfo.line_price"
              placeholder="请输入划线价"
              size="mini"
            ></el-input>
            <el-popover placement="top-start" width="200" trigger="hover">
              <div>在备考通app上显示的划线价格</div>
              <i class="el-icon-question el-icon--right" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <div class="userInfoFormStyle-price">
            <div class="userInfoFormStyle-price-item">
              <span>指导价：{{ userInfo.price }}</span>
            </div>
            <div v-if="is_show_cost_price" class="userInfoFormStyle-price-item">
              <span>成本价：{{ userInfo.cb_good_price }}</span>
            </div>
          </div>
          <el-form-item label="老师提成：" prop="">
            <el-input
              v-model="userInfo.tc_per_txt"
              placeholder=""
              type="number"
              style="width: 100px"
              size="mini"
              :disabled="!is_update_teacher_tc"
              @blur="goodRatioChange(userInfo.tc_per_txt)"
            ></el-input>
            % * 销售价 =
            <span style="color: #d9001b">{{
              Math.floor(
                (userInfo.tc_per_txt / 100) * userInfo.good_price * 100
              ) / 100
            }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="addUser('userInfoForm')"
            size="medium"
            >确 定</el-button
          >
          <el-button @click="addFormShow = false" size="medium"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 上传弹窗 -->
    <el-dialog title="导入学员" :visible.sync="outerVisible" width="500px">
      <div style="margin-bottom: 40px">
        <el-input
          placeholder="请输入内容"
          v-model="fileName"
          class="input-with-select"
        >
          <el-upload
            style="display: inline-block; margin: 0 15px"
            action="/上传文件的接口"
            :on-change="onChange"
            :auto-upload="false"
            :show-file-list="false"
            slot="append"
            accept=".xls, .xlsx"
          >
            <el-button type="success" size="small">选取文件</el-button>
          </el-upload>
        </el-input>
      </div>
      <el-steps align-center>
        <el-step
          title="下载导入excel"
          description="下载excel模版"
          @click.native="downloadExcel"
        >
        </el-step>
        <el-step title="录入相关信息"></el-step>
        <el-step title="导入excel"></el-step>
      </el-steps>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importFile" size="mini"
          >确 定</el-button
        >
        <el-button @click="excelImport" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="instructionsVisible"
      class="formDialog"
      width="1200px"
    >
      <iframe
        :src="instructionsExplain"
        :width="instructionsWidth"
        :height="instructionsHeight"
        frameborder="0"
        allowfullscreen
      />
    </el-dialog>

    
    <el-dialog
      title=""
      :visible.sync="kefuDialogVisible"
      class="formDialog"
      width="500px"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <span>技术对接和充值：{{ kefuData.teacher_name }}</span>
        <span style="padding-bottom: 20px; padding-top: 20px"
          >联系方式：{{ kefuData.teacher_mobile }}</span
        >
        <el-image
          style="width: 100px; height: 100px"
          :src="kefuData.qrcode"
          :preview-src-list="[kefuData.qrcode]"
        />
        <span style="padding-bottom: 20px">微信咨询 扫码联系</span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import commonApi from "@/api/common";
import studentApi from "@/api/student.js";
import goodsApi from "@/api/goods.js";
import qee from "qf-export-excel";
import { clearObj, copyToClip } from "@/utils/index.js";
import { deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "BktOtherGoods", 
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      outerVisible: false,
      fileName: "",
      excelList: [],
      importId: "",
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        name: "",
        subject_cate_id: 1399,
        is_show_open: 1
      },
      columns: [
        //列数据
        // { label: "序号", prop: "sortId" },
        // { label: "商品名称", prop: "name" },
        // { label: "所属考试", prop: "subject_info_name" },
        // { label: "商品类型", prop: "goods_type_name" },
        // { label: "权益说明", prop: "intro_desc" },
        // { label: "有效期（天）", prop: "day", width: 100 },
        // { label: "成本价", prop: "cb_good_price" },
        // { label: "正常销售价", prop: "good_price" },
        // { label: "划线价", prop: "line_price" },
        // { label: "老师推广提成", prop: "teachExtend", width: 120 },
        // { label: "操作", prop: "operation", width: 200 },
      ],
      tableFunction: {
        checkData: 0, //是否允许勾选
      },
      tableList: [],

      columnsCourse: [
        { label: "序号", prop: "serial" },
        { label: "课程名称", prop: "name" },
        { label: "试听", prop: "operation" },
      ],
      tableCourse: [],
      tableFunctionCourse: {
        height: 360,
      },
      // 新增编辑表单数据
      addFormShow: false,
      userShow: false,
      userInfo: {
        cover_small: "",
        course_name: "",
        price: "",
        line_price: "",
        good_price: "",
      },
      // subject_cate_ids: [1399, 289, 352],
      rules: {
        line_price: [
          { required: true, message: "请输入划线价格", trigger: "blur" },
        ],
        good_price: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      is_study_card: "",
      instructions: "开通商品使用说明xxxxxxxxx",
      instructionsVisible: false,
      instructionsWidth: "100%",
      instructionsHeight: "500px",
      instructionsExplain: "",
      is_show_cost_price: "",
      is_update_teacher_tc: "",
      role: "",
      subject_cate_list:[], 
      kefuDialogVisible: false,
      kefuData: {},
    };
  },
  computed: {
    dialogType() {
      // ${this.userInfo.course_name}
      return this.userShow
        ? `商品详情`
        : "修改价格信息";
    },
    isSalespersonr() { 
      return this.$store.state.user.userInfo.role == "salespersonr";
    },
    isNstitutionalteacher() { 
      return this.$store.state.user.userInfo.role == "nstitutionalteacher";
    },
  },
  watch: {
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.userInfo);
        }
      },
    },
  },
  created() {
    this.getMe();
    this.getDic();
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === "development") {
      this.instructionsExplain =
        "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongProductactivation&apptype=beikaotong";
    } else {
      this.instructionsExplain =
        "http://qmb.meite.com/task/#/web?key=beikaotongProductactivation&apptype=beikaotong";
    }
    this.getTobHideMenu();
    this.queryTable();
  },
  methods: {  
    getDic() { 
      commonApi.getInfoToName({ name: "orderamountlimit" }).then((res) => {
        console.log("1----", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "contacts") {
              this.kefuData.teacher_name = item.value;
            } else if (item.key == "contacts_moblie") {
              this.kefuData.teacher_mobile = item.value;
            } else if (item.key == "quickresponse") {
              this.kefuData.qrcode = item.value;
            }
          });
        }
      });
    },
    openKefu() {
      // this.callStatusDialogVisible = false;
      this.kefuDialogVisible = true;
    }, 
    async changeShowOrHidden(row) {
      const params = {
        id: row.tob_good_id,
        status: row.tob_good_status == 1 ? 0 : 1
      }
      console.log("changeShowOrHidden", params, row)
      const res = await goodsApi.tobGoodUpdateStatus(params);
      if (res.code == 200) {
        this.$message.closeAll();
        this.$message({
          type: "success",
          message: "切换成功！"
        });
        this.queryTable();
      }else{ 
        this.$message.error(res.message)
        this.queryTable();
      }
    }, 
    isShowCostPrice(e) {
      if (e) {
        this.columns = [
          // { label: "序号", prop: "sortId" },
          { label: "商品ID", prop: "id" },
          { label: "商品名称", prop: "name" },
          { label: "所属考试", prop: "subject_info_name" },
          { label: "商品类型", prop: "goods_type_name" },
          { label: "权益说明", prop: "intro_desc" },
          // { label: "有效期（天）", prop: "day", width: 100 },
          { label: "成本价", prop: "cb_good_price" },
          { label: "指导价", prop: "vip_price" },
          { label: "APP展示的出售价格（元）", prop: "tob_good_price" },
          { label: "APP展示的划线价格（元）", prop: "tob_line_price" },
          { label: "状态", prop: "tob_good_status_name", width: 80, isMyself: true }, 
          { label: "老师推广提成", prop: "teachExtend", width: 120 },
          { label: "操作", prop: "operation", width: 200 },
        ];
      } else {
        this.columns = [
          // { label: "序号", prop: "sortId" },
          { label: "商品ID", prop: "id" },
          { label: "商品名称", prop: "name" },
          { label: "所属考试", prop: "subject_info_name" },
          { label: "商品类型", prop: "goods_type_name" },
          { label: "权益说明", prop: "intro_desc" },
          // { label: "有效期（天）", prop: "day", width: 100 },
          { label: "指导价", prop: "vip_price" },
          { label: "APP展示的出售价格（元）", prop: "tob_good_price" },
          { label: "APP展示的划线价格（元）", prop: "tob_line_price" }, 
          { label: "状态", prop: "tob_good_status_name", width: 80, isMyself: true }, 
          { label: "老师推广提成", prop: "teachExtend", width: 120 },
          { label: "操作", prop: "operation", width: 200 },
        ];
      }

      if(this.role != 'salespersonr'){
        this.columns.forEach((item,index)=>{
          if(item.prop=='vip_price'){
            this.columns.splice(index, 1)
          }
          if(item.prop=='teachExtend'){
            this.columns.splice(index, 1)
          }
        })
      }
      
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.is_show_cost_price = res.data.is_show_cost_price;
        this.is_update_teacher_tc = res.data.is_update_teacher_tc;
        this.role = res.data.role;
        this.isShowCostPrice(res.data.is_show_cost_price);
        this.$forceUpdate();
        console.log("this.role", this.role);
      }
    },
    async getTobHideMenu() {
      await goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          this.is_study_card = res.data.is_study_card;
        }
      });
    },
    instructionsClick() {
      this.instructionsVisible = true;
    },
    openKamil() {
      // 使用卡密开通
      this.$router.push({
        path: "/cardManage",
        // query: {
        //   tobGoodId: row.tob_good_id,
        //   memberId: row.id,
        //   price: row.price,
        // },
      });
    },
    // 商品售价比例改变
    goodRatioChange(num) {
      console.log("失去焦点", num);
      this.userInfo.tc_per_txt = Math.floor(num * 100) / 100;
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      // this.queryInfo.subject_cate_ids = this.subject_cate_ids.toString();
      this.queryInfo.other_type = 1;
      const res = await goodsApi.vipList(this.queryInfo);
      //  res);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        this.tableList.forEach((item, index) => {
          this.tableList[index].sortId =
            (this.queryInfo.page - 1) * this.queryInfo.limit + (index + 1);
          // this.tableList[index].daySouce = this.tableList[index].day + '天'
        });


        if(res.data.subject_cate_list.length < 2){
          this.columns.forEach((item,index) => {
            if(item.prop == 'subject_info_name'){
              this.columns.splice(index, 1)
            }
          })
        }   
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    async viewDetail(row, _type) {
      this.userShow = _type;
      // 如果是编辑就不发送请求了
      if (this.userShow == 0) {
        this.userInfo = deepClone(row);
        console.log("课程详情", this.userInfo);
        this.userInfo.good_name = row.name;
        this.userInfo.cover_small = row.cover_small;
        this.userInfo.price = row.price; // 指导价
        this.userInfo.good_price = row.good_price
          ? row.good_price
          : row.course_price; // 销售价
        this.userInfo.line_price = row.line_price
          ? row.line_price
          : row.course_line_price; // 划线价
        this.userInfo.id = row.id;
        this.userInfo.tc_per_txt = this.userInfo.tc_per_txt.replace("%", "");
        this.addFormShow = true;
        return;
      }
      // const res = await goodsApi.vipDetail({id:row.id})
      // if(res.code == 200){
      this.addFormShow = true;
      Object.assign(this.userInfo, row);
      //   this.userInfo = res.data
      //   this.userInfo.cover_small = row.cover_small
      //   this.userInfo.price = row.price
      //   this.userInfo.id = row.id
      //   this.tableCourse = this.userInfo.data[0].son_chapter_list
      //    'this.userInfo',this.userInfo);
      // }
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        console.log("userInfo", this.userInfo);
        // 销售价小于成本价时
        if (+this.userInfo.good_price < +this.userInfo.cb_good_price) {
          this.$message({
            message: "请重新配置价格，销售价不得小于成本价",
            type: "error",
          });
          return;
        }
        // 当老师提成应小于商品的正常销售价-成本价时
        let teachGet =
          Math.floor(
            (this.userInfo.tc_per_txt / 100) * this.userInfo.good_price * 100
          ) / 100;
        if (
          +teachGet >
          +this.userInfo.good_price - +this.userInfo.cb_good_price
        ) {
          this.$message({
            message: "老师提成应不能大于商品的正常销售价-成本价，请调低比例",
            type: "error",
          });
          return;
        }
        if (valid) {
          let _obj = {
            type: 2,
            price: this.userInfo.good_price,
            line_price: this.userInfo.line_price,
            relation_id: this.userInfo.id,
            tc_per: this.userInfo.tc_per_txt,
          };
          //  '_____obj____',_obj);
          const res = await goodsApi.updateGoodsPrice(_obj);
          if (res.code == 200) {
            this.$message.success("修改成功!");
            this.addFormShow = false;
            this.queryTable();
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 删除数据
    deleteData(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editCode(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("修改成功!");
          this.resetCodeShow = false;
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        name: "",
      };
      // this.subject_cate_ids = [1399, 289, 352];
      this.queryTable();
    },
    // 从学员列表导入
    skipStudent(row) {
      this.$router.push({
        path: "/studentSelect",
        query: {
          tobGoodId: row.tob_good_id,
          memberId: row.id,
          price: row.cb_good_price,
          group_id: row.group_id,
        },
      });
    },
    // 批量导入
    // 文件选择回调
    onChange(file, fileList) {
      //  fileList);
      this.fileData = file; // 保存当前选择文件
      //  file);
      this.fileName = file.name;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      let that = this;
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = that.XLSX.read(data, {
            type: "binary",
            raw: true,
          });
          // if (workbook.SheetNames.length >= 1) {
          //   this.$message.success("表格导入成功")
          // }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = that.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.outputs = []; //清空接收数据
          let _list = [];
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              app_keys:
                ws[i][
                  "考试类别*（必填）【可选填“高职单招”,“成考”，可多选(用逗号隔开）】"
                ],
              realname: ws[i]["真实姓名*（必填）【至少两个中文汉字】"],
              mobile: ws[i]["手机号（填写后可使用手机号登录）"],
              id_card: ws[i]["身份证号"],
              remark: ws[i]["备注"],
              username: ws[i]["用户名【老学员还需要填写用户名，即登陆账号】"],
            };
            _list.unshift(sheetData);
          }
          this.excelList = _list;
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    openImport(row) {
      this.outerVisible = true;
      this.importId = row.tob_good_id;
    },
    skipImportRecordDetail(recordId) {
      this.$router.push({
        path: "/importRecordDetail",
        query: {
          recordId: recordId,
        },
      });
    },
    importFile() {
      if (this.excelList.length) {
        this.excelList = JSON.stringify(this.excelList);
        studentApi
          .studentsImport({
            data: this.excelList,
            type: 2,
            tob_good_id: this.importId,
          })
          .then((res) => {
            if (res.code == 200) {
              this.fileName = "";
              this.excelList = [];
              this.queryTable();
              this.outerVisible = false;
              this.$alert("导入成功", "提示", {
                confirmButtonText: "查看导入数据",
                callback: (action) => {
                  if (action == "confirm") {
                    this.skipImportRecordDetail(res.data.record_id);
                  }
                },
              });
            } else {
              this.$message.error(res.message);
            }
          });
      } else {
        this.$message.error("请先填入数据");
      }
    },
    excelImport() {
      this.fileName = "";
      this.excelList = [];
      this.outerVisible = false;
    },
    downloadExcel() {
      window.open(
        "https://img2.meite.com/question/import/studentimport230407.xls",
        "_blank"
      );
      // var titleList = [
      //   { title: "真实姓名（必填）【至少两个中文汉字】", key: "realname" },
      //   { title: "手机号（填写后可使用手机号登录）", key: "mobile" },
      //   { title: "身份证号", key: "id_card" },
      //   { title: "备注", key: "remark" },
      //   {
      //     title: "用户名【老学员还需要填写用户名，即登陆账号】",
      //     key: "username",
      //   },
      // ];
      // var dataSource = [];
      // var fileName = "学员信息导入模版";
      // qee(titleList, dataSource, fileName);
    },
    SkipImportStudent(row) {
      this.$router.push({
        path: "/importStudent",
        query: {
          id: row.tob_good_id,
          name: row.name,
          price: row.price,
        },
      });
    },
    skipImportRecord(row) {
      this.$router.push({
        path: "/importRecord",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 30px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0 20px 0;
    .el-button {
      margin-bottom: 5px;
    }
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  // .operationItem {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #00c793;
  // }
  // .operationItem:hover {
  //   color: red;
  // }
  // .operationItemNew {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #846ffd;
  //   border: 1px solid #846ffd;
  //   border-radius: 4px;
  //   font-size: 13px;
  //   padding: 0 10px;
  // }
  // .operationItemNew:hover {
  //   color: red;
  //   border: 1px solid red;
  // }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }
      p {
        margin-bottom: 10px;
      }
      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          border-radius: 10px;
        }
      }
    }
    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }
      .t2 {
      }
      .t3 {
      }
    }
    .userInfoFormStyle-price {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      justify-content: start;
      padding: 0 20px;
      .userInfoFormStyle-price-item {
        width: 50%;
      }
    }
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

.teach-extend-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teach-extend-box-tc {
    color: #d9001b;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
/deep/.tob_good_status_box .el-button--success{
    background: linear-gradient(234deg, #9583ff 0%, #7057ff 100%);
    border-color: #9583ff;
    opacity: 1;
    padding: 5px 10px;
    font-size: 12px;
}
/deep/.tob_good_status_box .el-button--success:hover{
    color: #846ffd; 
    border: 1px solid #846ffd;
    background: #fff;
}
/deep/.tob_good_status_box .el-button{
  color: #fff;
}
/deep/.tob_good_status_box .el-button--info{
  color: #FFF;
  background-color: #909399;
  border-color: #909399;
  opacity: 1;
  padding: 5px 10px;
  font-size: 12px;
}
</style>
